module.exports = __webpack_public_path__ + "cityCompressed.jpeg";